import { isSameDay } from "date-fns/isSameDay"
import { getDailyCurrencyRateList } from "../services/currency/currency.api"
import { isAfter, eachMonthOfInterval, format, endOfMonth, isSameMonth, subDays, isWeekend } from "date-fns"
import { toZonedTime } from "date-fns-tz"

import { addDbItem, getDbItem } from "../utils/idb-util"

export async function getExchangeRates({ baseCurrency, currencies, startDate, endDate }) {
    const fxrRates = []

    const today = new Date()

    if (isAfter(startDate, today) || isAfter(startDate, endDate)) {
        return fxrRates
    }

    const months = eachMonthOfInterval({
        start: startDate,
        end: endDate,
    })

    for (const month of months) {
        let endMonthDate = endOfMonth(month)

        if (isAfter(month, today)) {
            continue
        }

        if (isSameMonth(today, month) && isAfter(month, endOfMonth(today))) {
            endMonthDate = subDays(today, 1)

            if (isWeekend(endMonthDate)) {
                endMonthDate = subDays(today, 3)
            }
        }

        const monthKey = `${baseCurrency}-${format(month, "yyyy-MM")}`

        try {
            const cf = await getDbItem("orgExchangeRates", "fxStore", monthKey)

            if (cf) {
                fxrRates.push(...cf.exchangeRates)
                continue
            }
        } catch (e) {}

        const serverFx = await getDailyCurrencyRateList(baseCurrency, {
            startDate: month,
            endDate: endMonthDate,
        })

        await addDbItem("orgExchangeRates", "fxStore", {
            id: monthKey,
            exchangeRates: serverFx,
        })

        fxrRates.push(...serverFx)
    }

    return fxrRates
}

export function getFxForTheDay({ baseCurrency, exchangeRates, currency, day, app }) {
    if (!exchangeRates || !exchangeRates.length) return 1

    if (isAfter(day, new Date())) {
        day = new Date()
    }

    const dayRate = exchangeRates.find((r) => isSameDay(r.day, day)) || exchangeRates[exchangeRates.length - 1]

    let rateAmount

    try {
        rateAmount = dayRate?.rates[currency]
    } catch (e) {
        app?.silentFail("getFxForTheDay")
    }

    return rateAmount ? 1 - (rateAmount - 1) : 1
}

export async function grabExchangeRates({ missions, baseCurrency, startDate, endDate }) {
    if (!missions?.length) {
        return []
    }

    const hasAnotherCurrency = missions.some((m) => m.currency !== baseCurrency)

    if (hasAnotherCurrency) {
        const fxrRates = await getExchangeRates({ baseCurrency, startDate, endDate })

        return fxrRates
    }

    return []
}
